<template>
  <Select
    transfer
    v-model="shipping"
    :placeholder="placeholder"
    @on-change="change_value"
  >
    <Option v-for="item in options" :value="item.value" :key="item.value">
      {{ item.label }}
    </Option>
  </Select>
</template>

<script>
import { getParams } from "./utils";
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择运输方式"
    },
    param: {
      type: Object,
      default: () => {
        return {
          filter: "a.order_posttype",
          op: "="
        };
      }
    }
  },
  data() {
    return {
      shipping: "",
      options: [
        { value: 0, label: "全部方式" },
        { value: 1, label: "航运" },
        { value: 2, label: "空派" },
        { value: 3, label: "自发货" },
        { value: 4, label: "海外仓" },
        { value: 5, label: "其他" }
      ]
    };
  },
  methods: {
    change_value(val) {
      let params = getParams(this.param.filter, val, this.param.op);
      console.log(params);
      this.$emit("get", params, Boolean(val));
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/basic-filter/BaseShipping.vue